<template>
  <div>
    <div v-if="!hideScore">
      成功完成当前任务后，预计获得分数：
      <span class="font-bold text-primary">
        {{ fixNumber(seasonScore) }}
      </span>
    </div>
    <div
      v-if="
        (seasonScoreDetail.baseScore > 0 ||
          seasonScoreDetail.userExtraScore > 0 ||
          seasonScoreDetail.previousMissionExtraScore > 0) &&
        showDetail
      "
      class="score-details"
    >
      <div ref="baseScoreRef" class="score-item">
        基础分数: {{ fixNumber(seasonScoreDetail.baseScore) }}
      </div>

      <div
        v-if="seasonScoreDetail.userExtraScore > 0"
        ref="userExtraScoreRef"
        class="score-item"
      >
        多人奖励: +{{ fixNumber(seasonScoreDetail.userExtraScore) }}
      </div>
      <div
        v-if="seasonScoreDetail.previousMissionExtraScore > 0"
        ref="previousMissionScoreRef"
        class="score-item"
      >
        前情奖励: +{{ fixNumber(seasonScoreDetail.previousMissionExtraScore) }}
      </div>
      <div
        v-if="
          seasonScoreDetail.difficultyLevel &&
          seasonScoreDetail.difficultyLevel > 1 &&
          (dispatchMission.status !== DispatchStatus.Settled ||
            dispatchMission.isSuccess)
        "
        ref="difficultyScoreRef"
        class="score-item"
      >
        任务成功奖励： *{{ seasonScoreDetail.difficultyLevel }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { MateDispatch } from "@/types/entity";
import { computed, ref, onMounted } from "vue";
import gsap from "gsap";
import {
  getPreviousMissionCount,
  getUserCount,
  journalExtraScore,
  userExtraScore,
  baseScore,
  previousMissionExtraScore,
  fixNumber,
} from "./MissionStat";
import { DispatchStatus } from "@/enums/mission";

const props = defineProps<{
  dispatchMission: Partial<MateDispatch>;
  showDetail?: boolean;
  hideScore?: boolean;
  enableAnimation?: boolean;
}>();

// 添加 refs
const baseScoreRef = ref<HTMLElement | null>(null);
const userExtraScoreRef = ref<HTMLElement | null>(null);
const previousMissionScoreRef = ref<HTMLElement | null>(null);
const difficultyScoreRef = ref<HTMLElement | null>(null);

const seasonScoreDetail = computed(() => {
  return {
    baseScore:
      baseScore * journalExtraScore(props.dispatchMission.duration! / 2),
    userExtraScore:
      getUserCount(props.dispatchMission.dispatchMemberzz || []) *
      userExtraScore,
    previousMissionExtraScore:
      getPreviousMissionCount(props.dispatchMission as MateDispatch) *
      previousMissionExtraScore,
    difficultyLevel: props.dispatchMission.difficultyLevel,
  };
});

const seasonScore = computed(() => {
  return (
    (seasonScoreDetail.value.baseScore +
      seasonScoreDetail.value.userExtraScore +
      seasonScoreDetail.value.previousMissionExtraScore) *
    (seasonScoreDetail.value.difficultyLevel ?? 1)
  );
});

// 添加动画效果
onMounted(() => {
  const elements = [
    baseScoreRef.value,
    userExtraScoreRef.value,
    previousMissionScoreRef.value,
    difficultyScoreRef.value,
  ].filter((el) => el !== null);

  if (!props.enableAnimation) {
    // 如果动画被禁用，直接设置为显示状态
    gsap.set(elements, {
      opacity: 1,
      y: 0,
    });
    return;
  }

  // 初始化所有元素
  gsap.set(elements, {
    opacity: 0,
    y: -20,
  });

  // 创建时间轴
  const tl = gsap.timeline();

  // 为每个元素添加动画
  elements.forEach((el, index) => {
    tl.to(el, {
      opacity: 1,
      y: 0,
      duration: 0.5,
      ease: "back.out(1.7)",
      delay: index * 0.2,
    });
  });
});
</script>

<style scoped>
.score-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.score-item {
  position: relative;
}
</style>
